import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NeverOverpayNav from './NeverOverpayNav';
import { neveroverpayApi } from './neveroverpayApi';
import { auditLabel, stateLabel, workflowLabel } from './neveroverpayCopy';
import './neveroverpay.css';

export default function NeverOverpayOps() {
  const [queue, setQueue] = useState(null);
  const [audit, setAudit] = useState([]);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);

  function load() {
    Promise.all([neveroverpayApi.opsQueue(), neveroverpayApi.opsAudit()])
      .then(([q, a]) => {
        setQueue(q);
        setAudit(a.events || []);
      })
      .catch((err) => setError(err.message));
  }

  useEffect(() => { load(); }, []);

  return (
    <div className="np-root" data-testid="neveroverpay-ops">
      <div className="np-wrap">
        <NeverOverpayNav mark="Activity" />
        {error ? <div className="np-error">{error}</div> : null}
        {notice ? <div className="np-notice">{notice}</div> : null}
        <div className="np-actions" style={{ marginBottom: 16 }}>
          <Link className="np-btn ghost" to="/admin">Open settings</Link>
          <button
            type="button"
            className="np-btn ghost"
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              setError('');
              try {
                const row = await neveroverpayApi.deadlineSweep();
                setNotice(`Checked deadlines: ${row.expired} expired, ${row.flagged_waiting} still waiting on a company.`);
                load();
              } catch (err) {
                setError(err.message);
              } finally {
                setBusy(false);
              }
            }}
          >
            Check overdue renewals
          </button>
        </div>
        <div className="np-grid-3" style={{ marginBottom: 24 }}>
          {(queue?.playbooks || []).map((p) => (
            <div className="np-card" key={`${p.merchant_slug}-${p.workflow}`}>
              <h3>{p.merchant}</h3>
              <p className="np-muted">{workflowLabel(p.workflow)} · email {p.to}</p>
              <p className="np-muted">Usually works {(p.success_rate * 100).toFixed(0)}% of the time</p>
            </div>
          ))}
        </div>
        {(queue?.tasks || []).length ? (
          <div className="np-card" style={{ marginBottom: 24 }}>
            <h3>Needs a person</h3>
            {(queue.tasks || []).map((task) => (
              <div className="np-case-row" key={task.id}>
                <div>
                  <div className="np-pill">{task.kind}</div>
                  <div style={{ marginTop: 8 }}>{task.instructions}</div>
                </div>
                <div className="np-muted">{task.status}</div>
              </div>
            ))}
          </div>
        ) : null}
        <div className="np-card">
          <h3>All recoveries</h3>
          {(queue?.cases || []).map((c) => (
            <Link to={`/cases/${c.id}`} key={c.id} className="np-case-row">
              <div>
                <div className="np-pill">{stateLabel(c.state)}</div>
                <div style={{ marginTop: 8 }}>{c.title} {c.needs_ops ? '· needs a person' : ''}</div>
              </div>
              <div className="np-money">{c.estimated_display}</div>
            </Link>
          ))}
        </div>
        <div className="np-card" style={{ marginTop: 16 }}>
          <h3>What happened</h3>
          {audit.map((row) => (
            <div className="np-case-row" key={row.id}>
              <div>{auditLabel(row.action)}</div>
              <div className="np-muted">{row.at}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
